<template>
  <div id="company">
  <section>
    <h3><span class="h3_line"><span class="h3_deco"></span>{{product.product.title}}</span></h3>
      <section class="product">
			<div>
			<div class="appeal_icons">
				<span class="badge-netis" v-if="product.product.netis">NETIS商品</span><br>
        <span class="badge-netis" v-if="isNew(product)">新入荷商品</span>
        <span class="badge-netis" v-if="isRec(product)">おすすめ商品</span>
        <span class="badge-netis" v-if="isDes(product)">災害支援商品</span>
			</div>
			<div class="icon-area">
        <span class="badge-cert badge-tokukyou" v-if="product.product.qualification_sp_teach">特教</span>
        <span class="badge-cert badge-gi" v-if="product.product.qualification_skill">技</span>
        <span class="badge-cert badge-men" v-if="product.product.driver_license">免</span>
        <span class="badge-cert badge-tokujiken" v-if="product.product.checking_tokujiken">特自検</span>
        <span class="badge-cert badge-dennbou" v-if="product.product.checking_denhou">電訪</span>
        <span class="badge-cert badge-syaken" v-if="product.product.checking_shaken">車検</span>
        <span class="badge-cert badge-youken" v-if="product.product.checking_souken">揚検</span>
        <span class="badge-cert badge-teiji" v-if="product.product.checking_teiji">定時</span>
				<div v-html="iconAboutHtml"></div>
      </div>
			</div>
        <ul class="product_image">
          <li>
            <img id="main-image" :src="mainImage" :alt="product.product.title" @error="setNoImage">
          </li>
        </ul>
        <ul class="product_thumb">
          <li v-if="loadImage[0]"><img class="thumbnail" v-on:click="changeMainImage(kenkiImagePath(0))" :src="kenkiImagePath(0)" @error="setNoImage"></li>
          <li v-if="loadImage[1]"><img class="thumbnail" v-on:click="changeMainImage(kenkiImagePath(1))" :src="kenkiImagePath(1)" @error="setNoImage"></li>
          <li v-if="loadImage[2]"><img class="thumbnail" v-on:click="changeMainImage(kenkiImagePath(2))" :src="kenkiImagePath(2)" @error="setNoImage"></li>
          <li v-if="loadImage[3]"><img class="thumbnail" v-on:click="changeMainImage(kenkiImagePath(3))" :src="kenkiImagePath(3)" @error="setNoImage"></li>
          <li v-if="loadImage[4]"><img class="thumbnail" v-on:click="changeMainImage(kenkiImagePath(4))" :src="kenkiImagePath(4)" @error="setNoImage"></li>
        </ul>
        <h4>仕様</h4>
        <div class="product_cation_wrap">
          <table class="product_cation">
            <thead><tr>
              <th width="1%">商品コード</th>
              <th width="10%" v-for="item in lelatedProducts" :key="item.id">
                <router-link :to="{name: 'singleCode' ,params: {Code: item.code}}">{{item.name}}</router-link>
              </th>
            </tr></thead>
            <tbody id="product-spec-table" class="table" v-html="specPage">
            </tbody>
          </table>
        </div>
        <p class="product_text" v-html="brbr(product.spec_comment)"></p>
      
        <!-- h3 class="large">比較検討商品</h3>
        <ul class="product__comparison">
							<li><a href="#">
								<img src="/_img/catalog/sample/img1.png" alt="">
								<p>0.07</p>
								<p>クボタ</p>
								<p>U-17</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img2.png" alt="">
								<p>0.07</p>
								<p>クボタ</p>
								<p>U-17</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img1.png" alt="">
								<p>0.07</p>
								<p>クボタ</p>
								<p>U-17</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img2.png" alt="">
								<p>0.07</p>
								<p>クボタ</p>
								<p>U-17</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img1.png" alt="">
								<p>0.07</p>
								<p>クボタ</p>
								<p>U-17</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img2.png" alt="">
								<p>0.07</p>
								<p>クボタ</p>
								<p>U-17</p>
							</a></li>
        </ul -->
      
        <div v-if="product.product.description_b">
          <h4>商品説明</h4>
          <p class="product__text" v-html="brbr(product.product.description_a)"></p>
          <p class="product__text" v-html="brbr(product.product.description_b)"></p>
        </div>
      
        <!-- h3 class="product__relation">関連商品（オプション・販売品など）</h3>
							<li><a href="#">
								<img src="/_img/catalog/sample/img1.png" alt="">
								<p>組合せ品</p>
								<p>業務用無線機（特定小電力無線機）&nbsp;ヘルメット用ヘッドセット&nbsp;R9C 00007</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img2.png" alt="">
								<p>組合せ品</p>
								<p>業務用無線機（特定小電力無線機）&nbsp;ヘルメット用ヘッドセット&nbsp;R9C 00007</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img1.png" alt="">
								<p>組合せ品</p>
								<p>業務用無線機（特定小電力無線機）&nbsp;ヘルメット用ヘッドセット&nbsp;R9C 00007</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img2.png" alt="">
								<p>組合せ品</p>
								<p>業務用無線機（特定小電力無線機）&nbsp;ヘルメット用ヘッドセット&nbsp;R9C 00007</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img1.png" alt="">
								<p>組合せ品</p>
								<p>業務用無線機（特定小電力無線機）&nbsp;ヘルメット用ヘッドセット&nbsp;R9C 00007</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img2.png" alt="">
								<p>組合せ品</p>
								<p>業務用無線機（特定小電力無線機）&nbsp;ヘルメット用ヘッドセット&nsbsp;R9C 00007</p>
							</a></li>
        </div -->
      
        <div v-if="product.staff_comment">
          <div v-if="product.staff_comment_published"> 
            <h3>担当者より</h3>
            <p class="p-2">{{product.staff_comment}}</p>
          </div>        
        </div>

        <!-- div v-if="product.price_info">
          <div v-if="product.price_info_published">
            <h3>参考価格</h3>
            <dl class="product__price"><dt>レンタル料金（日割）</dt><dd></dd></dl>
            <dl class="product__price"><dt>基本料金/サポート料金（日割）</dt><dd>{{product.price_info}}</dd></dl>
          </div>
        </div -->
      
        <div v-if="product.video_license_published && product.video_license_valid">
          <h3>動画</h3>
          <div class="product_wideo"><iframe width="100%" height="400" :src="product.video_url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <p class="product_text">{{product.video_comment}}</p>
        </div>

        <div v-if="product.file_props.length">
          <h3>ダウンロード</h3>
          <ul class="download_link">
            <li v-for="(file,index) in product.file_props" v-bind:key="index">
              <a :href="file.url" download="file.url" target="_blank" rel="noopener noreferrer"><i class="icon-pdf"></i>{{file.name}}</a>
            </li>
          </ul>
        </div>
      
        <div v-if="product.link_props">
          <h3> 関連サイト</h3>
          <ul id="links" class="relatin_link">
            <div v-for="(myLink,index) in product.link_props" v-bind:key="index">
              <li><a :href="myLink.url" target="_blank">{{myLink.name}}</a></li>   
            </div>
          </ul>
        </div>
      
        <div v-if="product.faq">
          <div v-if="product.faq_published">
            <h3>FAQ</h3>
            <table class="product__faq">
              <tbody>
                <tr><td>
                  <span class="produt__faq_answer" v-html="brbr(product.faq)"></span>
                </td></tr>
              </tbody>
            </table>
          </div>
        </div>
						<!-- table class="product__faq">
							<tr><th><span class="product__faq_question">Q</span></th><td>個人でも借りることはできますか？</td></tr>
							<tr><th><span class="product__faq_answer">A</span></th><td>はい。個人の方もご利用いただけます。レンタル手続きの流れに従って連絡ください。</td></tr>
						</table>
						<table class="product__faq">
							<tr><th><span class="product__faq_question">Q</span></th><td>借りた営業所とは違う営業所に返却してもいいですか?</td></tr>
							<tr><th><span class="product__faq_answer">A</span></th><td>お借りいただいた営業所で精算いたしますので、別の営業所への返却はできません。</td></tr>
						</table -->

          <!-- div v-if="product.description">
            <div v-if="product.description_published">
              <h3>備考</h3>
              <p class="product_text">{{product.description}}</p>
            </div>
          </div -->        
      
          <!-- div v-if="product.address_info">
            <div v-if="product.address_info_published">
              <h3>お問い合わせ</h3>
                <p class="product__text">{{product.address_info}}</p>
            </div>
          </div -->        
       
          <!--
						<h3> 商品バックナンバー</h3>
						<ul class="product__backno">
							<li><a href="#">
								<img src="/_img/catalog/sample/img1.png" alt="">
								<p>0.007m3 バックホー後方小旋回 PC01</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img2.png" alt="">
								<p>0.007m3 バックホー後方小旋回 PC01</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img1.png" alt="">
								<p>0.007m3 バックホー後方小旋回 PC01</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img2.png" alt="">
								<p>0.007m3 バックホー後方小旋回 PC01</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img1.png" alt="">
								<p>0.007m3 バックホー後方小旋回 PC01</p>
							</a></li>
							<li><a href="#">
								<img src="/_img/catalog/sample/img2.png" alt="">
								<p>0.007m3 バックホー後方小旋回 PC01</p>
							</a></li>
						</ul>
          -->
    </section>
    </section>
    </div>
</template>

<script>
  //import products from "@/assets/jsons/stock_products.json"
  
  export default {
    data: function () {
      return {
        //params
        product_id: this.$route.params.Id,
        chartered_product_id: this.$route.params.CharterId,
        product_code: this.$route.params.Code,
        //
        product: {
            'product': {
              'product_code': ''
            },
            'image_props': [],
            'file_props': [],
            'link_props': []
        },
        mainImage: '',
        specPage: '',
        specFile: {
          isLoad: false,
          loadedCsv: ''
        },
        lelatedProducts: [],
        // meta
        title: '取扱商品',
        description: '',
        keywords: '',
        // image load
        loadImage: [true, true, true, true, true],
        kenki_image_path: process.env.VUE_APP_KENKI_IMAGE_PATH,
        iconAboutHtml: '',
        baseUrl: process.env.BASE_URL || '/'
      }
    },
    props: {
      categorySet: {
        type: Array,
        require: true
      }
    },
    methods: {
      setNoImage: function (event) {
        if (!event || !event.target) return
        event.target.onerror = null
        event.target.src = this.baseUrl + 'img/noimage.png'
      },
      setBreadcrumbId: function (id) {
        if (this.$parent) {
          this.$parent.category_id = id
        }
        if (this.$root) {
          this.$root.category_id = id
        }
      },
      setBreadcrumbTitle: function (title) {
        if (this.$parent) {
          this.$parent.active_page_title = title
        }
        if (this.$root) {
          this.$root.active_page_title = title
        }
      },
      syncBreadcrumbs: function () {
        var categoryId = this.product.category_id
        if (!categoryId && this.product.category && this.product.category.id) {
          categoryId = this.product.category.id
        }
        this.setBreadcrumbId(categoryId || null)
        this.setBreadcrumbTitle(this.product.product && this.product.product.title ? this.product.product.title : '')
      },
      kenkiImagePath: function (n) {
        return this.kenki_image_path + this.product.product.product_code + '-' + ('00' + (n+1)).slice(-2) + '.jpg'
      },
      loadKenkiImage: function (n) {
        this.$axios.get(this.kenkiImagePath(n))
        .then(res => {
          this.loadImage[n] = true
        })
        .catch(e => {
          this.loadImage[n] = false
        })          
      },
      isNew: function (p) {
        if(!p.sub_categories) return false;
        var news = [];
        news = p.sub_categories.filter(function(item){
          if((item.name).indexOf("新入荷") >= 0) return true;
        })
        return news.length;
      },
      isRec: function (p) {
        if(!p.sub_categories) return 0;
        var recs =[];
        recs = p.sub_categories.filter(function(item){
          if((item.name).indexOf("おすすめ") >= 0) return true;
        })
        return recs.length;
      },
      isDes: function (p) {
        if(!p.sub_categories) return 0;
        var dess = [];
        dess = p.sub_categories.filter(function(item){
          if((item.name).indexOf("災害") >= 0) return true;
        })
        return dess.length;
      },
      changeMainImage: function (path) {
        this.mainImage = path;
      },
      makeSpec: function (d, name, code) {      
        const dataArray = this.parseCSV(d,',');
        var strongPos = -1
        var tableType = 'old'
        var items = []
        var colval = ''
        var colsize = dataArray[0].length
        if(dataArray[1][0]=='' || dataArray[1][0] == 'product_tag'){
          tableType = 'new'
          strongPos = dataArray[1].indexOf(code)
        }else{
          tableType = 'old'
          strongPos = dataArray[1].indexOf(name)
        }
        let insertElement = ''
        for(var i=0; i < dataArray.length; i++){
         if(i==0) continue;
         if(i==1 && (dataArray[i][0] == '' || dataArray[i][0] == 'product_tag')) continue;
         insertElement += '<tr>';
         //for(var j=0; j<dataArray[i].length; j++){
         for(var j=0; j<colsize; j++){
           if(i==1){
             if(j>0) items.push({'id': j, 'code': dataArray[i][j], 'name': dataArray[i][j]})
           }else if(i==2 && tableType=='new'){
             if(j>0) items.push({'id': j, 'code': dataArray[1][j], 'name': dataArray[i][j]})
           }else{
             if(j==0){
               insertElement += `<th width="10%">${dataArray[i][j]}</th>`;
             }else if(j==strongPos){
               insertElement += `<td style="background:rgba(255,0,0,0.3)">${dataArray[i][j]}</td>`;
             }else{
               insertElement += `<td>${dataArray[i][j]}</td>`;
             }
           }     
         }
         insertElement += '</tr>';
        }
        //insertElement += '</tbody>'
        this.specPage = insertElement
        this.lelatedProducts = items
      },
      parseCSV: function(text = '',delim) {
        if (!delim) delim = ',';
        var tokenizer = new RegExp(delim + '|\r?\n|[^' + delim + '"\r\n][^' + delim + '\r\n]*|"(?:[^"]|"")*"', 'g');
        var record = 0, field = 0, data = [['']], qq = /""/g;
        text.replace(/\r?\n$/, '').replace(tokenizer, function(token) {
          switch (token) {
            case delim: 
              data[record][++field] = '';
              break;
            case '\n': case '\r\n':
              data[++record] = [''];
              field = 0;
              break;
            default:
              var colvar = (token.charAt(0) != '"') ? token : token.slice(1, -1).replace(qq, '"')
              var reg = new RegExp(/^[1-9][0-9]*$|^[1-9][0-9]*\.0+$/)
              if(reg.test(colvar)) colvar = Number(colvar).toLocaleString()
              data[record][field] = colvar
          }
        });
        var cleanData = [['']]
        for(var n=0;n<data.length;n++){
          if(JSON.stringify(data[n][0]) !== JSON.stringify("")){
          //if(JSON.stringify(data[n][0]) !== JSON.stringify([""])){
            cleanData[n] = data[n]
          }
        }
        return cleanData
      },
      loadCsvFile: function (file) {
        this.$axios.get(file)
        .then(res => {
          this.specFile.loadedCsv = res.data
          this.specFile.isLoad = true
          if(this.specFile.isLoad) this.makeSpec(this.spcFile.loadedCsv, this.product.product.product_name, this.product.product.product_code)
        })
        .catch(e => {
          this.specFile.loadedCsv = this.product.spec
          this.specFile.isLoad = false
          this.makeSpec(this.product.spec, this.product.product.product_name, this.product.product.product_code)
        })
      },
      brbr: function(text){
        if(!text) text ='';
        var brtext = text.replace(/\r?\n/g, '<br>');
        return brtext;
      },
      getProduct: function () {
        this.lelatedProducts = []
        var myToken = process.env.VUE_APP_TOKEN
        var myComId = process.env.VUE_APP_COMPANY_ID
        var filter_id = this.product_id
        var params = {}
        var url = process.env.VUE_APP_URL + '/stock_products/' + filter_id
        if(this.product_code){
          url = process.env.VUE_APP_URL + '/stock_products/search/'
          params = {
            'limit': 1, 
            'stock_product': {
              'product': {
                'product_code': this.product_code
              },
              'company_id': myComId
            }
          }
          fetch(url, {
            method: "POST",
            mode: "cors",
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ${myToken}`              
            },
            body: JSON.stringify(params)
          })
          .then(res => {
            return res.json()
          })
          .then(data =>{
            this.product = data[0]
            this.changeMainImage(this.kenkiImagePath(0))
            for(var i=0;i<5;i++) this.loadKenkiImage(i)
            this.loadCsvFile('/spec_csv/' + this.product.category.name + '.csv')
            this.title = this.product.product.title
            this.syncBreadcrumbs()
          })
          .catch(e => console.error(e))          
        }else{
          if(this.chartered_product_id){
            filter_id = this.chartered_product_id;
            url = process.env.VUE_APP_URL + '/chartered_stock_products/' + filter_id;          
          }
          fetch(url, {
            method: "GET",
            mode: "cors",
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ${myToken}`
            }
          })
          .then(res => {
            return res.json()
          })
          .then(data =>{
            this.product = data
            this.changeMainImage(this.kenkiImagePath(0))
            for(var i=0;i<5;i++) this.loadKenkiImage(i)
            this.loadCsvFile('/spec_csv/' + this.product.category.name + '.csv')
            this.title = this.product.product.title
            this.syncBreadcrumbs()
          })
          .catch(e => console.error(e))          
        }
      }
    },
    created () {
      this.getProduct()
    },
    mounted () {
      this.syncBreadcrumbs()
      var baseUrl = process.env.BASE_URL || '/'
      fetch(baseUrl + 'parts/icon_about.html')
        .then(function (res) {
          if (!res.ok) {
            throw new Error('icon_about.html load failed: ' + res.status)
          }
          return res.text()
        })
        .then(function (html) {
          this.iconAboutHtml = html
        }.bind(this))
        .catch(function (e) {
          console.error(e)
        })
    },
    watch: {
      '$route': 'getProduct',
      'title': function (){
          if (this.$root && this.$root.setPageMeta) {
            this.$root.setPageMeta(this.product.product.title, this.product.meta_description, this.product.meta_keywords)
          } else {
            this.$parent.title = this.product.product.title
            this.$parent.description = this.product.meta_description
            this.$parent.keywords = this.product.meta_keywords
          }
          //breadcrumbs
          this.syncBreadcrumbs()
      },
      'specFile.isLoad': function(){
          if(this.specFile.isLoad){
            this.makeSpec(this.specFile.loadedCsv, this.product.product.product_name, this.product.product.product_code)
          }else if(this.product.spec){
            this.makeSpec(this.product.spec, this.product.product.product_name, this.product.product.product_code)
          }
      },
      categorySet(newSet){
        this.syncBreadcrumbs()
      },
    },
    beforeRouteUpdate(to, from, next){
      this.product_code = to.params.Code
      this.product_id = null
      this.chartered_product_id = null
      this.specPage = ''
      next()
      this.syncBreadcrumbs()
    },
    beforeRouteLeave(to, from, next){
      if(to.params.Code){
        this.product_code = to.params.Code
        this.product_id = null
        this.chartered_product_id = null
        this.specPage = ''
        next()
        this.syncBreadcrumbs()
      }else{
        next()
      }
    }
  }
</script>

<style>
</style>
